<script setup lang="ts">
import { defineAsyncComponent, onBeforeMount, ref, shallowRef, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { Check, CircleX, Gift, Route, ThumbsDown, ThumbsUp, User, WandSparkles } from 'lucide-vue-next'
import { useRoute } from 'vue-router'
import RainbowButtonBig from '../utils/RainbowButtonBig.vue'
import { useAuthStore } from '@/stores/authStore'
import Tools from '@/utils/tools'
import Footer from '@/components/Footer.vue'
import AnimatedBackground from '@/components/utils/AnimatedBackground.vue'
import { useNotificationStore } from '@/stores/notificationStore'
import { ENotificationType } from '@/types'
import router from '@/router'

const props = defineProps<Props>()

interface Props {
	status: 'success' | 'cancel'
}
const { t } = useI18n()

const discordLink = ref<string>(import.meta.env.VITE_DISCORD_INVITE_LINK ?? '')

onBeforeMount(() => {
	if (!document.referrer.includes('nowpayments')) {
		router.replace('/explore')
	}
})
</script>

<template>
	<div class="menu:min-h-[calc(100dvh-100px)] px-4 min-h-[calc(100dvh-140px)] menu:mt-[120px] mt-[150px] w-screen">
		<AnimatedBackground />
		<div class="inset-0 absolute flex-center flex-col gap-4">
			<h1 class="flex-center gap-2 text-2xl sm:text-3xl md:text-4xl lg:text-6xl font-black bg-gradient-to-r from-white via-purple-200 to-pink-200 bg-clip-text text-transparent my-0 mb-2 leading-tight">
				<component
					:is="status === 'success' ? Check : CircleX"
					class="lucide-button-icon-lg"
					:class="{
						'text-emerald-400': status === 'success',
						'text-red-400': status === 'cancel',
					}"
				/>
				{{ t('shop.crypto_status.title') }}
			</h1>

			<div class="text-slate-200 text-center px-4 text-sm sm:text-base">
				{{ t(`shop.crypto_status.${status}`) }}
			</div>

			<RainbowButtonBig
				v-if="status === 'success'"
				:label="t('common.create')"
				:icon="WandSparkles"
				@click="router.push('/create')"
			/>
			<a
				v-else
				:href="discordLink"
				target="_blank"
				class="button-indigo no-underline"
				label="Discord"
				icon="pi pi-discord"
			>
				<i class="pi pi-discord" />
				<span>
					Discord
				</span>
			</a>
		</div>
	</div>
	<Footer />
</template>

<style scoped lang="scss">
.modal {
	background: linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #334155 100%);
	@apply shadow-2xl shadow-slate-700/80 mx-auto flex items-center justify-center relative overflow-hidden flex-col max-w-[450px] rounded-xl pb-14 px-6;
}
</style>
